import template from './library.html';
import controller from './library.controller';
import './library.less';

let libraryComponent = {
  restrict: 'E',
  bindings: {
  	linkText: '@'
  },
  template,
  controller
};

export default libraryComponent;



// WEBPACK FOOTER //
// ./src/app/pages/library/library.component.js